import React, { useState } from "react";
import PropTypes from "prop-types";
import SelectCircle from "@/assets/icons/hollow-circle.svg";

export default function IconChips({
  item,
  isSelected = false,
  onSelect,
  onHover,
  variant,
  showRevampDesign = false,
}) {
  const [isHovered, setIsHovered] = useState(false);

  const handleSelect = () => {
    onSelect(item);
  };

  const handleHover = (hoverState) => {
    setIsHovered(hoverState);
    if (onHover) onHover(item, hoverState);
  };

  if (showRevampDesign) {
    return (
      <div
        onClick={handleSelect}
        onMouseEnter={() => handleHover(true)}
        onMouseLeave={() => handleHover(false)}
        className={`flex flex-col items-center justify-center ${
          ["icon", "small-icon"].includes(variant)
            ? "  border border-[#777]"
            : "py-2 bg-chip-bg"
        } cursor-pointer ${
          isSelected ? `border-[0.5px] font-semibold border-[#424242]` : ""
        } ${
          variant === "icon"
            ? "flex-col p-2"
            : variant === "small-icon"
            ? "flex-row items-center justify-start gap-1 sm:text-base"
            : "flex-row p-2"
        }`}
        style={{
          overflow: "wrap",
        }}
      >
        {!variant === "icon" && (
          <div className="w-full flex items-start justify-start -mb-2">
            <img src={SelectCircle} alt="" />
          </div>
        )}
        {variant === "icon" && (
          <div
            className={`flex flex-col w-full items-center justify-between p-2`}
          >
            <div className="flex w-full justify-end">
              <img src={SelectCircle} alt="" />
            </div>
            <div className="flex justify-start items-center w-full">
              <img src={item.icon} alt={item.heading} className="w-24 max-h-20" />
              <span
                className={`text-[#eee] text-left pl-4 font-medium text-sm ${
                  variant === "small-icon" ? "text-xs" : ""
                }`}
              >
                {item.heading}
              </span>
            </div>
          </div>
        )}

        {variant === "small-icon" && (
          <img src={item.icon} alt={item.heading} className={`w-8 h-8`} />
        )}
        {!variant === "icon" && (
          <span
            className={`text-[#bbbbbb] se:text-2xs sm:text-2xs ${
              variant === "small-icon" ? "text-xs" : ""
            } `}
          >
            {item.heading}
          </span>
        )}
      </div>
    );
  } else {
    return (
      <div
        onClick={handleSelect}
        onMouseEnter={() => handleHover(true)}
        onMouseLeave={() => handleHover(false)}
        className={`flex items-center gap-2 cursor-pointer ${
          isSelected
            ? ["icon", "small-icon"].includes(variant)
              ? "font-medium border-[#222] text-[#eee] rounded-full"
              : `bg-white font-medium text-[#222] `
            : ""
        } ${
          ["icon", "small-icon"].includes(variant)
            ? "pr-6 bg-black border-2 border-[#222] justify-start"
            : "py-2 bg-chip-bg justify-center text-xs"
        }  ${
          variant === "icon"
            ? "flex-col p-2"
            : variant === "small-icon"
            ? "flex-row items-center justify-start gap-1 sm:text-base"
            : "flex-row p-2"
        }`}
        style={{
          overflow: "wrap",
        }}
      >
        {variant === "icon" && (
          <img
            src={item.icon}
            alt={item.heading}
            className={`se:w-20 se:h-20 sm:w-32 sm:h-32 p-2`}
          />
        )}
        {variant === "small-icon" && (
          <img
            src={item.icon}
            alt={item.heading}
            className={`m-1 p-1 w-16 h-16 as rounded-full bg-[#222]`}
          />
        )}
        <span
          className={` ${
            variant === "small-icon"
              ? "text-xs font-normal leading-5 tracking-wide text-[#eee]"
              : ""
          } `}
        >
          {item.heading}
        </span>
      </div>
    );
  }
}

IconChips.propTypes = {
  item: PropTypes.shape({
    icon: PropTypes.string,
    heading: PropTypes.string.isRequired,
    color: PropTypes.string,
    selectedColor: PropTypes.string,
    borderColor: PropTypes.string,
    selectedBorderColor: PropTypes.string,
    backgroundColor: PropTypes.string,
    selectedBackgroundColor: PropTypes.string,
  }).isRequired,
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func,
  onHover: PropTypes.func,
  variant: PropTypes.oneOf(["default", "icon", "small-icon"]),
  showRevampDesign: PropTypes.bool,
};
